import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import {Dialog, Button, Typography} from "@material-ui/core";
import {INewParcelaSection} from "../../../types";


import sector_1 from '../../../icons/help/sectores_1.png'
import sector_2 from '../../../icons/help/sectores_2.png'
import sector_3 from '../../../icons/help/sectores_3.png'
import sector_4 from '../../../icons/help/sectores_4.png'
import sector_5 from '../../../icons/help/sectores_5.png'
import sector_6 from '../../../icons/help/sectores_6.png'
import sector_7 from '../../../icons/help/sectores_7.png'
import sector_8 from '../../../icons/help/sectores_8.png'
import sector_9 from '../../../icons/help/sectores_9.png'
import sector_10 from '../../../icons/help/sectores_10.png'
import sector_11 from '../../../icons/help/sectores_11.png'
import sector_12 from '../../../icons/help/sectores_12.png'
import sector_13 from '../../../icons/help/sectores_13.png'
import sector_14 from '../../../icons/help/sectores_14.png'
import sector_15 from '../../../icons/help/sectores_15.png'
import sector_16 from '../../../icons/help/sectores_16.png'
import sector_17 from '../../../icons/help/sectores_17.png'
import sector_18 from '../../../icons/help/sectores_18.png'
import {NavigateBefore, NavigateNext} from "@material-ui/icons";


const texts = require('../../../texts/crearparcela.json');

const images = [
    sector_1,
    sector_2,
    sector_3,
    sector_4,
    sector_5,
    sector_6,
    sector_7,
    sector_8,
    sector_9,
    sector_10,
    sector_11,
    sector_12,
    sector_13,
    sector_14,
    sector_15,
    sector_16,
    sector_17,
    sector_18
]

interface IProps {
    seccion: INewParcelaSection
    idioma: string
    setCrearParcelaSection(seccion: INewParcelaSection): void
}

interface IState {
    text: Record<string, string>,
    image_texts: string[],
    index: number
}


class AyudaSector extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma],
        image_texts: [
            texts[this.props.idioma]["91"],
            texts[this.props.idioma]["92"],
            texts[this.props.idioma]["93"],
            texts[this.props.idioma]["94"],
            texts[this.props.idioma]["95"],
            texts[this.props.idioma]["96"],
            texts[this.props.idioma]["97"],
            texts[this.props.idioma]["98"],
            texts[this.props.idioma]["99"],
            texts[this.props.idioma]["100"],
            texts[this.props.idioma]["101"],
            texts[this.props.idioma]["102"],
            texts[this.props.idioma]["103"],
            texts[this.props.idioma]["104"],
            texts[this.props.idioma]["105"],
            texts[this.props.idioma]["106"],
            texts[this.props.idioma]["107"],
            texts[this.props.idioma]["108"]
        ],
        index: 0
    }

    handleNext = () => {
        this.setState({index: this.state.index + 1})
    }

    render () {
        return (
            <Dialog
                open={this.props.seccion == "AyudaSector"}
                onClose={() => this.props.setCrearParcelaSection('Sectores')}
                PaperProps={{
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: "center",
                        overflow: "hidden",
                        width: "80%",
                        height: "80%",
                        borderRadius: 40
                    }
                }}
                maxWidth={"xl"}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        height: 100,
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >

                    <Typography
                        style={{
                            textAlign: "center",
                            width: "80%",
                            fontSize: 18,
                            color: "#4C494B",
                            fontFamily: "Poppins",
                        }}
                    >
                        {this.state.image_texts[this.state.index]}
                    </Typography>

                </div>


                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        height: 'calc(100% - 150px)'
                    }}
                >

                    <div
                        style={{
                            width: 80,
                            height: "100%"
                        }}
                    >
                        {this.state.index > 0 &&
                            <Button
                                style={{
                                    width: "100%",
                                    height: "100%"
                                }}
                                onClick={() => {
                                    this.setState({index: this.state.index - 1})
                                }}
                            >
                                <NavigateBefore style={{width: 50, height: 50}}/>
                            </Button>
                        }
                    </div>


                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            width: 'calc(100% - 160px)',
                            height: "100%"
                        }}
                    >

                        <img
                        // imagen de ayuda
                            style={{
                               height: "100%"
                            }}
                            src={images[this.state.index]}
                            alt={'img'}
                        />

                    </div>


                    <div
                        style={{
                            width: 80,
                            height: "100%"
                        }}
                    >
                        {this.state.index < images.length - 1 &&
                            <Button
                                style={{
                                    width: "100%",
                                    height: "100%"
                                }}
                                onClick={() => this.handleNext()}
                            >
                                <NavigateNext style={{width: 50, height: 50}}/>
                            </Button>
                        }

                    </div>

                </div>

            </Dialog>
        )
    }

}

const mapStateToProps = (state: IStore) => ({
    seccion: state.crearParcela.seccion,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setCrearParcelaSection: (seccion: INewParcelaSection) => dispatch({type: "select-crear-parcela-seccion", seccion})
});

export default connect(mapStateToProps, mapDispatchToProps)(AyudaSector);
